import { render } from "./FavouritesComponent.vue?vue&type=template&id=6682bb84&scoped=true"
import script from "./FavouritesComponent.vue?vue&type=script&lang=js"
export * from "./FavouritesComponent.vue?vue&type=script&lang=js"

import "./FavouritesComponent.vue?vue&type=style&index=0&id=6682bb84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6682bb84"]])

export default __exports__